import styled from 'styled-components';

interface InputProps {
  variant?: 'default' | 'search';
  size?: 'small' | 'medium' | 'large';
  hasError?: boolean;
  fullWidth?: boolean;
}

const getSizeStyles = (size: string = 'medium') => {
  switch (size) {
    case 'small':
      return `
        padding: 8px 12px;
        font-size: 0.875rem;
      `;
    case 'large':
      return `
        padding: 16px 20px;
        font-size: 1.1rem;
      `;
    default:
      return `
        padding: 12px 16px;
        font-size: 0.95rem;
      `;
  }
};

export const Input = styled.input<InputProps>`
  ${props => getSizeStyles(props.size)}
  
  border: 2px solid ${props => props.hasError ? '#dc2626' : '#e1e8ed'};
  border-radius: 8px;
  transition: border-color 0.2s ease;
  width: ${props => props.fullWidth ? '100%' : 'auto'};
  background: white;
  
  &:focus {
    outline: none;
    border-color: ${props => props.hasError ? '#dc2626' : '#667eea'};
    box-shadow: 0 0 0 3px ${props => props.hasError ? 'rgba(220, 38, 38, 0.1)' : 'rgba(102, 126, 234, 0.1)'};
  }
  
  &:disabled {
    background: #f3f4f6;
    cursor: not-allowed;
    opacity: 0.6;
  }
  
  &::placeholder {
    color: #9ca3af;
  }
`;